<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>구매대행</h3>
				<h4>구매대행 안내</h4>
			</div>
			
			<div class="unit mb50">
				<div class="head" style="text-align: center;">
					구매대행이란?
				</div>
				<div class="img-box">
					<img v-if="!isMobile" src="../../assets/list/document_shopping_guide_img1.png" alt="" class="img-responsive">
					<img v-else src="../../assets/list/document_shopping_guide_m_img1.png" alt="" class="img-responsive">
				</div>
				<div class="description">
					해외 사이트의 직접 가입 및 이용 결제 등의 <br class="visible-xs">복잡한 과정없이 혹은 1688 등<br class="hidden-xs">
					직접 구매 결제가 어려운 <br class="visible-xs">사업자 회원님을 대신하여 중국 현지구매, 검수, <br class="visible-xs">통관, 국내배송까지<br class="hidden-xs">
					고로켓고에서 <br class="visible-xs"><strong>원스톱으로 대행해 드리는 서비스</strong>입니다.<br>
					<!-- 고로켓고에서는 1688의 경우 <br class="visible-xs">상품가 5% 할인 품목은 할인 적용해드립니다.<br>
					5% 할인 품목이 아닐 경우 할인혜택을 <br class="visible-xs">제공해드리지 못합니다. -->
				</div>
			</div>
		
			<div class="unit mb50">
				<div class="head" style="text-align: center;">
					구매대행 이용방법
				</div>
				<ul class="process">
					<li class="mb20">
						<el-row>
							<el-col :xs="24" :sm="20">
								<div class="text-area">
									<div class="title">
										<span class="num">01</span>
										<div class="text">구매대행 신청서를 작성해주세요.</div>
									</div>
									<div class="content">
										구매하실 상품의 정보를 정확하게 입력해 주세요.<br>
										요청사항이 있을 경우 입력해주시면 처리해 드릴께요.
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="4">
								<div class="img-box"><img class="img-radius" src="../../assets/list/document_shopping_guide_img2.png" alt=""></div>
							</el-col>
						</el-row>
					</li>
					<li class="mb20">
						<el-row>
							<el-col :xs="24" :sm="20">
								<div class="text-area">
									<div class="title">
										<span class="num">02</span>
										<div class="text">상품값 결제가 완료되면</div>
									</div>
									<div class="content">
										구매대행 신청서를 기준으로<br>
										접수하신 상품을 구매하며 이후 단계부터는<br>
										배송 신청서 단계가 됩니다.
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="4">
								<div class="img-box"><img class="img-radius" src="../../assets/list/document_shopping_guide_img3.png" alt=""></div>
							</el-col>
						</el-row>
					</li>
					<li class="mb20">
						<el-row>
							<el-col :xs="24" :sm="20">
								<div class="text-area">
									<div class="title">
										<span class="num">03</span>
										<div class="text">구매요청하신 상품이 도착하면</div>
									</div>
									<div class="content">
										작성하신 검수 / 포장 / 옵션에 맞게 작업 후 포장완료 후<br>
										무게측정을 하여 배송비 결제 안내 알림톡 안내를 합니다.
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="4">
								<div class="img-box"><img src="../../assets/list/document_shopping_guide_img4.png" alt=""></div>
							</el-col>
						</el-row>
					</li>
					<li class="mb20">
						<el-row>
							<el-col :xs="24" :sm="20">
								<div class="text-area">
									<div class="title">
										<span class="num">04</span>
										<div class="text">배송비 결제가 완료되면</div>
									</div>
									<div class="content">
										한국으로 배송됩니다.
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="4">
								<div class="img-box"><img class="img-radius" src="../../assets/list/document_shopping_guide_img5.png" alt=""></div>
							</el-col>
						</el-row>
					</li>
				</ul>
			</div>
					
			<div class="unit mb50">
				<div class="head">
					▶ 구매대행 사업자 회원님이 점검하셔야 할 부분
				</div>
				<div class="check-point mb50">
					<ul class="num-list mb20" >
						<li>
							<div class="num">1) </div>
							<div class="content">구매대행적용환율 / 구매대행수수료 / 배송비 / 부가서비스</div>
						</li>
						<li>
							<div class="num">2) </div>
							<div class="content">구매대행 적용환율이 <span class="color-orange">높으면</span> 구매대행 수수료가 <span class="color-orange">저렴하고</span></div>
						</li>
						<li>
							<div class="num">3) </div>
							<div class="content">구매대행 적용환율이 <span class="color-orange">저렴하면</span> 구매대행 수수료가 <span class="color-orange">높습니다.</span></div>
						</li>
						<li>
							<div class="num">4) </div>
							<div class="content">구매대행 적용환율과 구매대행 수수료 배송비가 <span class="color-orange">저렴하면</span> 부가서비스 비용이 <span class="color-orange">높습니다.</span></div>
						</li>
						<li>
							<div class="num">5) </div>
							<div class="content">고로켓고은 합법적해외 송금을 실행하고 있습니다.</div>
						</li>
					</ul>
					<div class="description color-orange"><strong>고로켓고의 구매대행 적용 환율과 구매대행 수수료, 배송비, 구매대행 부가서비스를 꼭 비교해 보시길 바랍니다.</strong></div>	
				</div>
				<div class="text-box">
					<ul class="dot-list">
						<li>적용환율은  ex) 주간고시환율 180 / 적용환율 190 / 주간고시환율 +10</li>
						<li>
							1 ~  299위안 : 20위안<br>
							300~499위안 : 5%<br>
							500~999위안 : 4%<br>
							1000위안이상 : 3%<br>
							구매대행 수수료는 구매대행 아이템별 금액 기준으로 수수료가 적용됩니다. (2025.01.01 적용)
						</li>
						<li>포장용 폴리백 (신청서당 1매) -&gt; 무상지원</li>
						<li>구매확정 / 후기 템플릿 동봉서비스 -&gt; 200원</li>
						<li>개봉 시 환불금지 스티커 -&gt; 무료</li>
						<li>한글설명서(A4) 동봉서비스 -&gt; 장당 200원</li>
						<!-- <li>개인회원은 구매대행 서비스를 지원하지 않습니다.</li> -->
					</ul>
				</div>
				
			</div>
					
		</div>
		<div style="text-align: center;" >
			<router-link to="/agencyShopping" class="register-button">
				구매대행 신청
			</router-link>
		</div>
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import { safePush } from '@/utils/router';
	export default {
		components: {
			BusinessBanner
		},
		data() {
			return{
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},		
		methods: {
			onCurrentNav(url){
				safePush(this.$router, url);
			},
		}
	
		
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.unit{
		
	}
	.unit .head {
	    font-weight: 700;
	    font-size: 26px;
	    line-height: 36px;
	  
	    margin-bottom: 25px;
		padding-left: 50px;
	}
	.img-box{
		display: flex;
		justify-content: center;
	}
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	.description{
		text-align: center;
		margin:20px 0;
	}
	.unit .process {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	.unit .process > li{
		display: flex;
		align-items: center;
		gap: 0 20px;
		padding: 80px;
		margin:0 60px;
		background: #FBF3EA;
		border-radius: 30px;
	}
	.unit .process > li .text-area {
		width: 400px;
	    flex: 1;
	}
	.unit .process > li .text-area .title {
	    display: flex;
	    align-items: center;
	    gap: 0 6px;
	    margin-bottom: 14px;
	}
	.unit .process > li .text-area .title .num {
	    width: 30px;
	    line-height: 30px;
	    background: #FFFFFF;
	    border-radius: 50%;
	    font-weight: 700;
	    font-size: 14px;
	    color: var(--main-color);
	    text-align: center;
	}
	.unit .process > li .text-area .title .text {
	    font-weight: 700;
	    font-size: 24px;
	    line-height: 29px;
	    color: #000000;
	}
	.unit .process > li .text-area .content {
		font-weight: 500;
		font-size: 17px;
		line-height: 1.8;
		color: #FF4000;
	}
	.check-point {
	    padding-left: 90px;
	    font-size: 17px;
	}
	ul.num-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	ul.num-list > li {
	    display: flex;
	    gap: 0 5px;
	    font-size: 17px;
	    line-height: 1.8;
	}
	.check-point .description {
	    text-align: left;
	}
	.text-box {
		margin:0 60px;
	    padding: 50px;
	    background: #FFFFFF;
	    border: 1px solid #D9D9D9;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	    border-radius: 30px;
	    font-size: 15px;
	}
	ul.dot-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
		color: var(--background-color);
	}
	ul.dot-list > li {
	    padding-left: 16px;
	    line-height: 30px;
	    position: relative;
	}
	ul.dot-list > li:before {
	    content: '';
	    display: block;
	    position: absolute;
	    top: 12px;
	    left: 0;
	    width: 6px;
	    height: 6px;
	    background: var(--main-color);
	    border-radius: 50%;
	}
	.register-button{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		margin-bottom: 40px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		cursor: pointer;
	}
	
	.img-radius{
		border-radius: 16px;
	}
	.color-orange {
	    color: #FF5C00 !important;
	}
	.mb20{
		margin-bottom: 20px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.visible-xs {
	    display: none !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {	
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;

			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.unit .head {
			font-size: 17px;
			padding-left: 0;
			text-align: center;
		}
		.unit .process > li{
			margin:0 10px;
			padding: 40px;
		}
		.img-box{
			margin-top: 20px;
		}
		.img-box img{
			width:200%;
			height: 200%;
		}
		.unit .process > li .text-area {
			width: auto;
		    flex: 1;
		}
		.unit .process > li .text-area .title .text {
			font-size: 17px;
		}
		.text-box {
			margin:0 10px;
		}
		
		.check-point {
		    padding: 0 10px;
		    font-size: 17px;
		}
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>